import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { ReactElement } from "react";
import { toast } from "react-hot-toast";
import { newRightArrowIcon } from "../../constant";
import { colors, palette, sp, fs, br, fw, statusColors } from "../../styles/design-tokens";

// const InfoIconComponent = (): ReactElement => <InfoOutlinedIcon sx={{ color: colors.neutral.white }} />;

const SuccessIconComponent = (): ReactElement => (
  <CheckCircleOutlineIcon sx={{ color: colors.neutral.white, width: 30, height: 30 }} />
);

// const CloseIconComponent = (): ReactElement => (
//   <CancelOutlinedIcon
//     sx={{ color: colors.neutral.white, width: 18, height: 18, cursor: "pointer" }}
//     onClick={() => toast.dismiss()}
//   />
// );

let currentToastId: string | null = null;

export const toastMessage = {
  success: (message: string, detailedMessage?: string) => {
    if (!message && !detailedMessage) return;
    if (currentToastId) toast.dismiss(currentToastId);
    currentToastId = toast(
      <div
        style={{
          maxWidth: "calc(100vw - 48px)",
          position: "relative",
          whiteSpace: "pre-line",
        }}
        onClick={() => toast.dismiss()}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            gap: sp(12), /* Figma audit: 12px gap */
          }}
        >
          <div>
            <CheckOutlinedIcon
              style={{
                width: "24px",
                height: "24px",
                color: `var(--zv-success, ${statusColors.success})`,
              }}
              htmlColor={statusColors.success}
            />
          </div>
          <div>
            <div
              style={{
                fontWeight: fw(500), /* Figma audit: fontWeight not fontStyle */
                color: `var(--zv-success, ${statusColors.success})`,
                fontSize: fs(16), /* Figma audit: 16px */
                wordBreak: "break-word",
                whiteSpace: "pre-wrap",
                marginTop: sp(3),
              }}
            >
              {message}
            </div>
            <div
              style={{
                fontWeight: fw(500), /* Figma audit: fontWeight not fontStyle */
                color: `var(--zv-success, ${statusColors.success})`,
                fontSize: fs(16), /* Figma audit: 16px */
              }}
            >
              {detailedMessage}
            </div>
          </div>
        </div>
      </div>,
      {
        duration: 3000,
        // icon: InfoIconComponent(),
        style: {
          backgroundColor: `var(--zv-success-tint, ${palette["green-95"]})`,
          borderRadius: br(8),
          padding: sp(12),
          width: "100%",
          boxShadow: "none",
          border: "none",
          outline: "none",
          margin: sp(0),
        },
      }
    );
    setTimeout(() => {
      toast.dismiss(currentToastId!);
      currentToastId = null;
    }, 3000);
  },
  newSuccess: (message: string, detailedMessage?: string) => {
    if (!message && !detailedMessage) return;
    if (currentToastId) toast.dismiss(currentToastId);
    currentToastId = toast(
      <div
        style={{
          position: "relative",
          whiteSpace: "pre-line",
          marginLeft: sp(-10),
          marginRight: sp(-10),
        }}
      >
        <div
          style={{
            fontWeight: fw(600),
            color: "#fffff",
            fontSize: fs(12),
            letterSpacing: "0.3px",
            marginLeft: sp(10),
          }}
        >
          {message || "SUCCESS"}
        </div>
        <div
          style={{
            fontStyle: "500",
            color: colors.neutral.white,
            fontSize: fs(10),
            letterSpacing: "0.2px",
            marginLeft: sp(10),
          }}
        >
          {detailedMessage}
        </div>
      </div>,
      {
        icon: SuccessIconComponent(),
        style: {
          background: `linear-gradient(180deg, ${palette["sky-70"]} 0%, ${palette["sky-29"]} 100%)`,
          borderRadius: br(6),
          border: `1.1px solid ${palette["White"]}`,
          color: colors.neutral.white,
          boxShadow: `${sp(0, 4, 4)} ${palette["black-a50"]}`,
        },
        duration: 3000,
      }
    );
    setTimeout(() => {
      toast.dismiss(currentToastId!);
      currentToastId = null;
    }, 3000);
  },
  selectSuccess: (message: string, detailedMessage?: string) => {
    if (!message && !detailedMessage) return;
    if (currentToastId) toast.dismiss(currentToastId);
    currentToastId = toast(
      <div
        style={{
          position: "relative",
          whiteSpace: "pre-line",
          marginLeft: sp(-80),
          marginRight: sp(-10),
        }}
      >
        <div
          style={{
            fontFamily: "var(--brand-font-body)",
            fontWeight: fw(500),
            color: colors.neutral.white,
            fontSize: fs(10),
            letterSpacing: "0.3px",
            marginLeft: sp(10),
          }}
        >
          {message || "SUCCESS"}
        </div>
        <div
          style={{
            fontFamily: "var(--brand-font-body)",
            fontWeight: fw(600), /* Figma audit: fontWeight not fontStyle */
            fontSize: fs(10),
            letterSpacing: "0.2px",
            marginLeft: sp(10),
            color: colors.neutral.white,
          }}
        >
          {detailedMessage}
        </div>
      </div>,
      {
        icon: <img src={newRightArrowIcon} alt="" style={{ width: "26px", height: "26px" }} />,
        style: {
          background: palette["blue-41-8"],
          borderRadius: br(6),
          border: `1.1px solid ${palette["White"]}`,
          color: colors.neutral.white,
          boxShadow: `${sp(0, 4, 4)} ${palette["black-a50"]}`,
          minWidth: "300px",
        },
        duration: 5000,
      }
    );
    setTimeout(() => {
      toast.dismiss(currentToastId!);
      currentToastId = null;
    }, 5000);
  },
  error: (message: string, detailedMessage?: string) => {
    if (!message && !detailedMessage) return;
    if (currentToastId) toast.dismiss(currentToastId);
    currentToastId = toast(
      <div
        style={{
          maxWidth: "calc(100vw - 48px)",
          position: "relative",
          whiteSpace: "pre-line",
        }}
        onClick={() => toast.dismiss()}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            gap: sp(12), /* Figma audit: 12px gap */
          }}
        >
          <div>
            <CloseOutlinedIcon
              style={{
                width: "24px",
                height: "24px",
                color: `var(--zv-error, ${statusColors.error})`,
              }}
              htmlColor={statusColors.error}
            />
          </div>
          <div>
            <div
              style={{
                fontWeight: fw(500), /* Figma audit: fontWeight not fontStyle */
                color: `var(--zv-error, ${statusColors.error})`,
                fontSize: fs(16), /* Figma audit: 16px */
                wordBreak: "break-word",
                whiteSpace: "pre-wrap",
                marginTop: sp(3),
              }}
            >
              {message}
            </div>
            <div
              style={{
                fontWeight: fw(500), /* Figma audit: fontWeight not fontStyle */
                color: `var(--zv-error, ${statusColors.error})`,
                fontSize: fs(16), /* Figma audit: 16px */
              }}
            >
              {detailedMessage}
            </div>
          </div>
        </div>
      </div>,
      {
        duration: 3000,
        // icon: InfoIconComponent(),
        style: {
          backgroundColor: `var(--zv-error-tint, ${palette["red-96"]})`,
          borderRadius: br(8),
          padding: sp(12),
          width: "100%",
          boxShadow: "none",
          border: "none",
          outline: "none",
          margin: sp(0),
        },
      }
    );
    setTimeout(() => {
      toast.dismiss(currentToastId!);
      currentToastId = null;
    }, 3000);
  },

  loading: (message: string) => {
    if (!message) return;
    toastMessage.success(message);
  },
  info: (message: string, detailedMessage?: string) => {
    if (!message && !detailedMessage) return;
    if (currentToastId) toast.dismiss(currentToastId);
    currentToastId = toast(
      <div
        style={{
          maxWidth: "calc(100vw - 48px)",
          position: "relative",
          whiteSpace: "pre-line",
        }}
        onClick={() => toast.dismiss()}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            gap: sp(12), /* Figma audit: 12px gap */
          }}
        >
          <div>
            <InfoOutlinedIcon
              style={{
                width: "24px",
                height: "24px",
                color: `var(--zv-info, ${statusColors.info})`,
              }}
              htmlColor={statusColors.info}
            />
          </div>
          <div>
            <div
              style={{
                fontWeight: fw(500), /* Figma audit: fontWeight not fontStyle */
                color: `var(--zv-info, ${statusColors.info})`,
                fontSize: fs(16), /* Figma audit: 16px */
                wordBreak: "break-word",
                whiteSpace: "pre-wrap",
                marginTop: sp(3),
              }}
            >
              {message}
            </div>
            <div
              style={{
                fontWeight: fw(500), /* Figma audit: fontWeight not fontStyle */
                color: `var(--zv-info, ${statusColors.info})`,
                fontSize: fs(16), /* Figma audit: 16px */
              }}
            >
              {detailedMessage}
            </div>
          </div>
        </div>
      </div>,
      {
        duration: 3000,
        // icon: InfoIconComponent(),
        style: {
          backgroundColor: `var(--zv-info-tint, ${palette["blue-95"]})`,
          borderRadius: br(8),
          padding: sp(12),
          width: "100%",
          boxShadow: "none",
          border: "none",
          outline: "none",
          margin: sp(0),
        },
      }
    );
    setTimeout(() => {
      toast.dismiss(currentToastId!);
      currentToastId = null;
    }, 3000);
  },
};
